import { useCallback, useEffect, useState } from 'react';

export const useBlockBrowserBack = (): [boolean, (value: boolean) => void] => {
  const [open, setOpen] = useState<boolean>(false);

  const blockBrowserBack = useCallback((): void => {
    window.history.go(1);
    setOpen(true); // ここでsetOpen(true)を呼び出す
  }, []);

  useEffect((): (() => void) => {
    window.history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', blockBrowserBack);

    return (): void => {
      window.removeEventListener('popstate', blockBrowserBack);
    };
  }, [blockBrowserBack]);

  return [open, setOpen];
};
